import { render, staticRenderFns } from "./d-signup-button.vue?vue&type=template&id=3f213a98&scoped=true&"
import script from "./d-signup-button.vue?vue&type=script&lang=js&"
export * from "./d-signup-button.vue?vue&type=script&lang=js&"
import style0 from "./d-signup-button.vue?vue&type=style&index=0&id=3f213a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f213a98",
  null
  
)

export default component.exports